module.exports = __webpack_public_path__ + "img/7.08a03f48.jpg";